import { gql } from '@apollo/client';
import { CITY_PMC_FIELDS } from 'graphql/fields/cityPmcFields';

export const READ_CITY_PMCS_BY_MEMBERGROUP = gql`
  ${CITY_PMC_FIELDS}
  query ReadCityPmcsByMemberGroup($input: CityPmcsMemberGroupInput!) {
    readCityPmcsByMemberGroup(input: $input) {
      ...CityPmcFields
    }
  }
`;
